// extracted by mini-css-extract-plugin
module.exports = {"background":"Footer_background__qrMdo","footerMain":"Footer_footerMain__AF8RC","footerCopyright":"Footer_footerCopyright__Zqrq7","footerList":"Footer_footerList__ZVjjw"};